import { Link } from "react-router-dom";
import { PageHeader, Panel, EmptyState } from "../../components/ui";

/**
 * There is no training-content table in the backend — no entity, no endpoint, nothing an org can
 * publish. The page used to render a fixture curriculum with a completion percentage, which read as
 * real progress against material that did not exist. Until the org can publish training, an honest
 * empty state is the whole page. Adding that store is its own piece of work.
 */
const TrainingPage = () => (
  <div>
    <PageHeader title="Training" />
    <Panel title="Curriculum">
      <EmptyState
        title="No training published yet"
        description="When the office publishes training material it will appear here. In the meantime the check list and price list cover what each service needs."
        action={
          <Link
            to="/partner/check-list"
            className="rounded-lg bg-teal-600 px-3 py-1.5 text-xs font-semibold text-white no-underline"
          >
            Open the check list
          </Link>
        }
      />
    </Panel>
  </div>
);

export default TrainingPage;
